// extracted by mini-css-extract-plugin
export default {"screen_container":"SEOLandingScreen_screen_container__bDCOH","imageBox_container":"SEOLandingScreen_imageBox_container__MGnaU"};